import { ProjectAction } from "../types/projectDataRanks"
import { Dispatch } from "react"
import { ProjectActionType } from "../types/projectDataRanks"
import projectApi from "../../api/projectDataRanksApi"

interface IGetProjectDataRanks {
  asin: string
  startDate: string
  endDate: string
  projectId: string
}

function getProjectDataRanks(params: IGetProjectDataRanks) {
  const { asin, startDate, endDate, projectId } = params
  return async (dispatch: Dispatch<ProjectAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_RANKS })
      const response = await projectApi.getRanksData({ asin, startDate, endDate, projectId })
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_RANKS_SUCCESS, payload: response })
    } catch (error) {
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_RANKS_ERROR,
        payload: "Error loading projects",
      })
    }
  }
}

export default {
  getProjectDataRanks,
}
